var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacherIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8999 14.7478C41.2313 14.7478 38.2578 11.7896 38.2578 8.13915C38.2578 4.49076 41.2313 1.53152 44.8999 1.53152C48.5656 1.53152 51.5391 4.49076 51.5391 8.13915C51.5391 11.7896 48.5656 14.7478 44.8999 14.7478Z",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8029 7.39349L29.6211 7.57491",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4044 7.57491L32.2227 7.39349",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8029 4.98372L29.6211 4.80231",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72175 17.2295L8.46094 17.4891",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99519 20.9399L4.73438 21.1998",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72175 21.1998L8.46094 20.9399",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99519 17.4891L4.73438 17.2295",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9109 17.4433L27.6018 13.4634C25.8511 10.4453 21.4738 10.4453 19.7227 13.4634L2.61617 42.9495C0.865473 45.9675 3.05378 49.7407 6.55518 49.7407H32.6101",
    stroke: "#FFC700",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4053 33.1496H22.9179C22.2302 33.1496 21.6563 32.6301 21.5923 31.9495L20.5763 22.8966C20.5026 22.1183 21.1177 21.4463 21.9029 21.4463H25.4203C26.2055 21.4463 26.8206 22.1183 26.7469 22.8966L25.7319 31.9495C25.6665 32.6301 25.0927 33.1496 24.4053 33.1496Z",
    stroke: "#FFC700",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9264 40.9256C26.9264 39.1317 25.4645 37.6769 23.6633 37.6769C21.8603 37.6769 20.3984 39.1317 20.3984 40.9256C20.3984 42.7199 21.8603 44.1733 23.6633 44.1733C25.4645 44.1733 26.9264 42.7199 26.9264 40.9256Z",
    stroke: "#FFC700",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7197 18.0193H38.3613C34.623 18.0193 31.5938 21.0353 31.5938 24.7553V30.0954C31.5938 32.2273 33.3303 33.9565 35.4736 33.9565H42.1011C43.7356 33.9565 45.0626 32.9103 45.0626 31.3171C45.0626 29.7229 43.7356 28.4299 42.1011 28.4299H37.9024C37.5035 28.4299 37.1797 28.109 37.1797 27.7121V25.0803",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6308 30.6737C56.3042 32.0421 57.195 33.0725 58.3185 33.6677C58.9564 34.0068 59.7455 33.6618 59.9015 32.9585L60.5732 29.9415C60.7279 29.243 60.1685 28.602 59.4497 28.6319C58.1954 28.6863 56.975 29.2285 56.6308 30.6737Z",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4044 4.80231L32.2227 4.98372",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7969 28.9518L46.0246 18.0193H60.8391L58.6535 28.7404",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7263 33.2914L56.7041 38.3034H41.8906L42.7897 33.8891",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1797 37.0985C37.1797 37.0996 37.181 37.1009 37.181 37.102V56.2856C37.181 58.0436 38.3153 59.4685 40.0456 59.4685C41.7759 59.4685 43.1786 58.0436 43.1786 56.2856V43.6841C43.1786 42.7402 43.9483 41.9742 44.8968 41.9742C45.8454 41.9742 46.615 42.7402 46.615 43.6841V56.2856C46.615 58.0436 48.0178 59.4685 49.7481 59.4685C51.478 59.4685 52.6127 58.0436 52.6127 56.2856V46.3463C52.6127 46.3451 52.614 41.5342 52.614 41.5319",
    stroke: "#4076B4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherIcon);
export default __webpack_public_path__ + "static/media/teacherIcon.4f868779d534c4bd8f532e6e90384efd.svg";
export { ForwardRef as ReactComponent };